if (!customElements.get('custom-video')) {
  class CustomVideo extends HTMLElement {
    constructor() {
      super()
      this.items = this.querySelectorAll('div');
      this.loadVideo()
    }

    loadVideo() {
      this.addEventListener('click', () => {
        if (this.hasAttribute('data-loaded')) {
          return;
        }
        this.render();
        this.setAttribute("data-loaded", "");
      });
    }
    render() {
      const id = this.dataset.id;
      this.innerHTML = `
<iframe 
  id="customVideo" 
  class="custom-video__iframe" 
  src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1" 
  title="YouTube video player" 
  frameborder="0" 
  allowfullscreen 
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
  referrerpolicy="strict-origin-when-cross-origin">
</iframe>

`;
    }
  }

  customElements.define('custom-video', CustomVideo);
}